import { render } from "./New.vue?vue&type=template&id=757a8f25&scoped=true&ts=true"
import script from "./New.vue?vue&type=script&lang=ts"
export * from "./New.vue?vue&type=script&lang=ts"

import "./New.vue?vue&type=style&index=0&id=757a8f25&scoped=true&lang=css"

import exportComponent from "F:\\Code\\PokervegasWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757a8f25"]])

export default __exports__